import { b2x } from '@b2x/react/src';

import { AppContext } from './AppContext';
import { Footer } from './Footer';
import { Header } from './Header';
import { Icomoon } from './Icomoon';
import { ModalsAndOffcanvasses } from './ModalsAndOffcanvasses';
import { AboutUsPage } from './pages/AboutUsPage';
import { AccountHomePage } from './pages/AccountHomePage';
import { AccountPage } from './pages/AccountPage';
import { ArticlePage } from './pages/ArticlePage';
import { BlogPage } from './pages/BlogPage';
import { CartPage } from './pages/CartPage';
import { ChangePasswordPage } from './pages/ChangePasswordPage';
import { CheckoutPage } from './pages/CheckoutPage';
import { Error404Page } from './pages/Error404Page';
import { ForgotPasswordPage } from './pages/ForgotPasswordPage';
import { HomePage } from './pages/HomePage';
import { LandingLoyaltyPage } from './pages/LandingLoyaltyPage';
import { LandingTemplateAPage } from './pages/LandingTemplateAPage';
import { LandingTemplateBPage } from './pages/LandingTemplateBPage';
import { LandingTemplateCPage } from './pages/LandingTemplateCPage';
import { LandingTemplateDPage } from './pages/LandingTemplateDPage';
import { LandingTemplateEPage } from './pages/LandingTemplateEPage';
import { NewsletterSubscribePage } from './pages/NewsletterSubscribePage';
import { ProductPage } from './pages/ProductPage';
import { PromotionPage } from './pages/PromotionPage';
import { RegistrationPage } from './pages/RegistrationPage';
import { SearchPage } from './pages/SearchPage';
import { ServicePage } from './pages/ServicePage';
import { TemplatePage } from './pages/TemplatePage';
import { ThankYouPage } from './pages/ThankYouPage';
import { ThankYouPageOrderFailed } from './pages/ThankYouPageOrderFailed';
import { WhoisPage } from './pages/WhoisPage';

export const App = () => {
  return (
    <AppContext>
      {(appContext, appStaticContext) => (
        <b2x.App
          icomoonElement={<Icomoon />}
          onAddToCartSuccess={appStaticContext.showCartOffcanvas}
          onAddToWishlistAsGuestButtonClick={appStaticContext.showAccountOffcanvas}
        >
          <b2x.SkipLinks className="d-none d-md-block" />
          <ModalsAndOffcanvasses />
          <div className="d-flex flex-column flex-grow-1">
            <Header />
            <div className="flex-grow-1">
              <b2x.router.MainRouter
                codeMappings={{
                  SITEMAP: <HomePage />,
                  SITE_ABOUT_US: <AboutUsPage />,
                  SITE_ACCOUNT: <AccountHomePage />,
                  SITE_CCN_AREA: { component: <AccountPage />, separateRouter: true },
                  SITE_CUSTOMER_CARE: { component: <ServicePage />, separateRouter: true },
                  SITE_LEGAL_AREA: { component: <ServicePage />, separateRouter: true },
                  //SITE_TAX_BENEFITS: <LandingTemplateBPage />,
                  SITE_TEMPLATE: <TemplatePage />,
                }}
                error404Page={<Error404Page />}
                fixedMappings={{
                  cart: <CartPage />,
                  'change-password': <ChangePasswordPage />,
                  checkout: <CheckoutPage />,
                  'forgot-password': <ForgotPasswordPage />,
                  newsletter: <NewsletterSubscribePage />,
                  'order-ko': <ThankYouPageOrderFailed />,
                  'order-ok': <ThankYouPage />,
                  register: <RegistrationPage />,
                  search: <SearchPage />,
                  template: <TemplatePage />,
                  whois: <WhoisPage />,
                }}
                templateMappings={{
                  ARTICLE_PAGE_CONTENT_TYPE: <ArticlePage />,
                  LANDING_LOYALTY_CONTENT_TYPE: <LandingLoyaltyPage />,
                  LANDING_TEMPLATE_A_PAGE_CONTENT_TYPE: <LandingTemplateAPage />,
                  LANDING_TEMPLATE_B_PAGE_CONTENT_TYPE: <LandingTemplateBPage />,
                  LANDING_TEMPLATE_C_PAGE_CONTENT_TYPE: <LandingTemplateCPage />,
                  LANDING_TEMPLATE_D_PAGE_CONTENT_TYPE: <LandingTemplateDPage />,
                  LANDING_TEMPLATE_E_PAGE_CONTENT_TYPE: <LandingTemplateEPage />,
                  MAGAZINE_PAGE_CONTENT_TYPE: <BlogPage />,
                  PROMOTION_PAGE_CONTENT_TYPE: <PromotionPage />,
                }}
                typeMappings={{
                  CATALOG: <SearchPage />,
                  LISTING: <SearchPage />,
                  PRODUCT: <b2x.ProductTypeSwitch default={<ProductPage />} />,
                }}
              />
            </div>
            <Footer />
            <div id="products-tiles-container"></div>
            <b2x.ETrustedShop shopId="X2959A1BC3CABF2C91DAEB4D62DC46A0C" />
          </div>
        </b2x.App>
      )}
    </AppContext>
  );
};
